<template>
  <form :class="$style.multipleChecks">
    <!-- text -->
    <label :class="$style.label">
      {{ form.label }}
    </label>

    <!-- wrapper -->
    <div :class="$style.inputWrapper">
      <!-- inputs -->
      <template v-for="(input, index) in form.inputs">
        <div
          :key="index"
          :class="{
            [$style.radioBox]: true,
            [$style.checked]: isChecked(input),
            [$style.checkedNewDesign]: isChecked(input) && isNewDesign,
            [$style.left]: index == 0,
            [$style.right]: index == 1,
            [$style.land]: el.is.land,
            [$style.phone]: el.is.phone
          }"
          @click="onChange(input)"
        >
          <!-- input label -->
          {{ input.label }}
        </div>
      </template>
    </div>
  </form>
</template>

<script>
import store from '@/store'
export default {
  props: {
    form: {
      type: Object
    }
  },
  data() {
    return {
      checked: null
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    isChecked(input) {
      return input.selectedValue !== ''
    },
    onChange(input) {
      const data = {
        slideName: input.slideName,
        formName: input.formName,
        name: input.name,
        value: input.value
      }
      store.dispatch('editRadio', data)

      this.$emit('check', data)
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.multipleChecks {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.inputWrapper {
  display: flex;
  justify-content: center;
}

.radioBox {
  box-sizing: border-box;
  width: 141px;
  height: 50px;
  position: relative;
  display: flex;
  background: $color_bg_light;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 22px;
  color: $color_font_5;
  cursor: pointer;
  border-top: 2px solid $color_grey_1;
  border-bottom: 2px solid $color_grey_1;
}

.left {
  border: 2px solid $color_grey_1;
  margin-right: -1px;
}

.right {
  border: 2px solid $color_grey_1;
  margin-left: -1px;
}

.label {
  display: block;
  width: 279px;
  font-size: 18px;
  color: $color_font_2;
  margin-bottom: 20px;
}

.checked {
  border: 3px $color_green_2 solid;
  color: $color_font_2;
  z-index: 100;
}
// note: new design
.checkedNewDesign {
  border: 3px solid #4b6e5a;
}

.land {
  width: 100px;
}
.phone {
  width: 50%;
}
</style>
